<template>
  <div class="c-progress-indicator l-flex l-flex--justify-between">
    <div
      v-for="(step, index) in localSteps"
      :key="index"
      class="c-progress-indicator__steps"
    >
      <div class="c-progress-indicator__step-container">
        <checkbox
          :aria-label="
            (step.active && !step.completed
              ? 'you are currently on the '
              : 'Navigate to the ') +
              step.title +
              'step.'
          "
          :aria-hidden-checkbox="true"
          :value="step.completed"
          class="c-progress-indicator__step c-checkbox--progress j-checkbox--progress-position"
          :class="checkboxClasses(step)"
          :disabled="step.disabled"
          @input="$emit('change', step)"
        >
          <p
            class="c-progress-indicator__label t-heading-10"
            :class="checkboxClasses(step)"
            aria-hidden="true"
          >
            {{ step.title }}
          </p>
        </checkbox>
        <span
          v-if="index != localSteps.length - 1"
          aria-hidden="true"
          class="c-progress-indicator__status-bar j-progress-indicator__status-bar-position"
        />
        <!-- :class="progressBarClasses(index)" -->
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "../checkbox/Checkbox";
import isMobile from "@mixins/isMobile";

export default {
  name: "ProgressIndicator",
  components: {
    Checkbox,
  },
  mixins: [
    //this.isMobile is true screen width < 900px
    isMobile,
  ],
  props: {
    steps: {
      type: Array,
      default: null,
    },
    selfUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      localSteps: [],
    };
  },
  computed: {},
  watch: {
    steps: {
      deep: true,
      handler() {
        this.localSteps = this.steps;
        // this.positionStatusBars();
      },
    },
  },
  mounted() {
    this.localSteps = this.steps;
    // this.positionStatusBars();
    //initial render is a little off, run it again in a bit
    // setTimeout(() => this.positionStatusBars(), 300);
  },
  methods: {
    goToStep(index) {
      if (this.selfUpdate) {
        for (let i = 0; i < this.localSteps.length; ++i) {
          if (i < index) {
            this.localSteps[i].completed = true;
          } else {
            this.localSteps[i].completed = false;
          }
        }
      }
      this.$emit("change", index);
    },
    // progressBarClasses(stepIndex) {
    //   let classes = {};
    //   if(stepIndex > 0) {
    //     if(this.localSteps[stepIndex-1].completed){
    //       classes["c-progress-indicator__status-bar--filled"] = true;
    //     }
    //   }
    //   return classes;
    // },
    checkboxClasses(step) {
      return {
        "c-progress-indicator--faded": !step.active,
      };
    },
    // positionStatusBars(){
    //   this.$nextTick(() => {
    //     let bars = this.$el.getElementsByClassName("j-progress-indicator__status-bar-position");
    //     let dots = this.$el.getElementsByClassName("j-checkbox--progress-position");
    //     if(dots.length !== bars.length){
    //       console.warn("Something went wrong rendering checkboxes");
    //       return;
    //     }
    //     let parentRectangle = this.$el.getBoundingClientRect();
    //     for(let i = 0; i < bars.length;++i){
    //       if(i === 0){
    //         bars[i].style.display = "none"; //first one doesn't show
    //         continue;
    //       }
    //       let lastDot = dots[i-1].getElementsByTagName("input")[0].getBoundingClientRect();
    //       let nextDot = dots[i].getElementsByTagName("input")[0].getBoundingClientRect();
    //       const isMobile = this.isMobile;
    //       let widthModifyer = isMobile ? 20 : 60;
    //       bars[i].style.left = (lastDot.right - parentRectangle.left + 21) + "px";
    //       bars[i].style.width = ((nextDot.left)- (lastDot.right) - widthModifyer) + "px";
    //     }
    //   });
    // }
  },
};
</script>

<style lang="scss" scoped>
.c-progress-indicator {
  // width: rem(260px);
  height: rem(75px);
  position: relative;

  &__step-container {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
  }

  &__label {
    text-transform: uppercase;
  }

  &__status-bar {
    margin-left: rem(4px);
    height: 1px;
    width: rem(60px);
    @include themify($themes) {
      border: 1px dashed themed("primary");
    }
    opacity: 0.5;
    top: 36%;
    transform: translateY(-50%);
    &--filled {
      opacity: 1;
      @include themify($themes) {
        border: 1px solid themed("primary");
      }
    }
  }

  &--faded {
    opacity: 0.5;
  }
}
</style>
